export const useCheckingUserForCreatingPurchase = true;
export const useCheckingUserForClosingCashboxJournal = true;
export const useImportExportExcel = true;
export const useInvoicesCurrencies = true;
export const useSocialMediaLinks = true;
export const setAllAsDefaultInsteadOfFavoritesOnSaleInvoice = false;
export const hideTaxOnSaleInvoice = false;
export const invertMoneyTypeColors = false;
export const useNewSaleInvoice = true;

// Attar
// export const useCheckingUserForCreatingPurchase = false;
// export const useCheckingUserForClosingCashboxJournal = true;
// export const useImportExportExcel = true;
// export const useInvoicesCurrencies = true;
// export const useSocialMediaLinks = false;
// export const setAllAsDefaultInsteadOfFavoritesOnSaleInvoice = false;
// export const hideTaxOnSaleInvoice = false;
// export const invertMoneyTypeColors = false;
// export const useNewSaleInvoice = false;

// Mirta
// export const useCheckingUserForCreatingPurchase = true;
// export const useCheckingUserForClosingCashboxJournal = true;
// export const useImportExportExcel = false;
// export const useInvoicesCurrencies = false;
// export const useSocialMediaLinks = false;
// export const setAllAsDefaultInsteadOfFavoritesOnSaleInvoice = true;
// export const hideTaxOnSaleInvoice = true;
// export const invertMoneyTypeColors = true;
// export const useNewSaleInvoice = true;

// Kadou
// export const useCheckingUserForCreatingPurchase = false;
// export const useCheckingUserForClosingCashboxJournal = false;
// export const useImportExportExcel = true;
// export const useInvoicesCurrencies = true;
// export const useSocialMediaLinks = true;
// export const setAllAsDefaultInsteadOfFavoritesOnSaleInvoice = false;
// export const hideTaxOnSaleInvoice = false;
// export const invertMoneyTypeColors = false;
// export const useNewSaleInvoice = false;